import styled from 'react-emotion';

interface ITextProps {
  color?: string;
  noShadow?: boolean;
  size?: string;
  textAlign?: 'center' | 'justify' | 'left' | 'right';
}

const Text = styled('span')`
  font-size: ${({ size }: ITextProps) => size || '1.5rem'};
  color: ${({ color }) => color || 'white'};
  text-align: ${({ textAlign }) => textAlign};
  text-shadow: ${({ noShadow }) => !noShadow && '1px 2px 0 black'};
`;

export default Text;



// WEBPACK FOOTER //
// ./src/components/Text.ts